import React, { Component } from 'react';

const Footer = (props) => { 
    return (
        <footer></footer>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.js